import React, { CSSProperties } from 'react';
import { AirtableDataConsumer, AirtableContextData } from '../core/AirtableDataProvider';
import AirtableImage from '../core/AirtableImage';

interface Props {
  children?: React.ReactNode
  subtitle?: React.ReactNode
}

export default class Title extends React.Component<Props> {

  render()
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data) }
      </AirtableDataConsumer>
    );
  }

  _render(data: AirtableContextData)
  {
    const params = data.pageParameters;

    const Title = params.getSingle('Title');
    const image = params.getImage('HeaderImage');
    const color = params.getValueOrNull('TitleColor');
    const bgColor = params.getValueOrNull('TitleBgColor');

    const subColor = params.getValueOrNull('SubtitleColor');
    const subBgColor = params.getValueOrNull('SubtitleBgColor');

    const subtitle = this.props.subtitle || Title.Content;

    const styles: CSSProperties = { };

    if (color) {
      styles.color = color;
    }

    if (bgColor) {
      styles.backgroundColor = bgColor;
    }

    const subStyles = { ...styles };

    if (subColor) {
      subStyles.color = subColor;
    }

    if (subBgColor) {
      subStyles.backgroundColor = subBgColor;
    }

    return (
      <AirtableImage
        image={ image }
        render={ url =>
          <div
            style={{ backgroundImage: `url(${url}` }}
            className="flex flex-column justify-center items-center tc bg-center cover">

            <h1
              className="f3 f2-ns bg-white-fade pv2 ph3 mt5 mb0 lh-copy"
              style={ styles }>{ Title.Value }</h1>

            { subtitle ?
              <p className="b bg-white-fade pv2 ph3 lh-copy" style={ subStyles }>{ subtitle }</p>
            : null }

            { this.props.children ? this.props.children : <div className="mv4"> </div> }

          </div>
        }
      />
    );
  }

}